<template lang="pug">
.support-warning(v-if="warningMessage")
    i.support-warning-icon.icon-warning-lozenge
    .support-warning-text
        h5.support-warning-title {{ $t(warningMessage.title) }}
        .support-warning-description {{ $t(warningMessage.description) }}
</template>
<script>
export default {
    name: 'SupportWarning',

    computed: {
        warningMessage() {
            if (this.$utils.browsers.canSetPartitionedCookies()) {
                return;
            }
            // The property `navigator.cookieEnabled` is true when partitionned cookies are enabled.
            // It does not mean that it is possible to set non-partitioned cookies
            if (navigator.cookieEnabled === false) {
                if (this.$utils.browsers.isSafari()) {
                    // Safari briefly supported Partitioned cookies in version 18.4 and then dropped it because of a bug.
                    // See https://bugs.webkit.org/show_bug.cgi?id=292975.
                    // Because of this we have to ask users to allow cross-site cookies in their settings.
                    // Note that there is an API to allow non-partitionned cookies (`requestStorageAccess`). However Safari
                    // will ignore all calls to it if the user did not first access SpotMe webapp without it being embedded.
                    // This defeats the purpose of embedding SpotMe registration in our customers' registration page.
                    return {
                        title: 'registration.support_warning.misconfigured_safari.title',
                        description: 'registration.support_warning.misconfigured_safari.description'
                    }
                } else if (this.$utils.browsers.isIOS()) {
                    // Currently, all browsers on IOS are forced to use Webkit, which has a bug
                    // https://github.com/mozilla-mobile/firefox-ios/issues/28774
                    // On IOS these browsers do not accept Partitioned cookies, and even when they do say they accept them,
                    // they will not save them. Safari is an exception for some reason. Thus we ask the user to use Safari.
                    return {
                        title: 'registration.support_warning.ios_browser_with_bug.title',
                        description: 'registration.support_warning.ios_browser_with_bug.description',
                    };
                } else {
                    // This is an unsupported browser. Chrome, Firefox, Edge all support this. Ask the user to use a supported
                    // browser.
                    return {
                        title: 'registration.support_warning.unsupported_browser.title',
                        description: 'registration.support_warning.unsupported_browser.description',
                    }
                }
            } else {
                // This means that the browser says that cookies are allowed, but it refuses to set them.
                // There is such a bug in ios browsers. See https://github.com/mozilla-mobile/firefox-ios/issues/28774
                // We then ask the user to use Safari.
                // This also happens if the user uses Safari private window on macos, enables the cross-site tracking,
                // and reload the tab. The browser then says it accepts cookies but actually refuses them. The user
                // needs to open a new tab to make it work.
                // Safari private window on mobile is also buggy, and opening a new tab does not solve the problem.
                return {
                    title: 'registration.support_warning.ios_browser_with_bug.title',
                    description: 'registration.support_warning.ios_browser_with_bug.description',
                }
            }
        }
    }
};
</script>
